import { Box, CardContent, Stack } from "@mui/material";
import { CardWithIntent, Illustration, Text } from "@src/appV2/redesign/system/ui-components";
import pluralize from "pluralize";

import { Button } from "../../components/Button";
import { useIsSmallHorizontalSpacing } from "../../utils/useIsSmallHorizontalSpacing";
import { useIsSmallVerticalSpacing } from "../../utils/useIsSmallVerticalSpacing";

interface PlacementGroupedDocumentRequirementsCardProps {
  requiredDocumentsCount: number;
  onClick: () => void;
}

export function PlacementGroupedDocumentRequirementsCard(
  props: PlacementGroupedDocumentRequirementsCardProps
) {
  const { requiredDocumentsCount, onClick } = props;

  const isSmallVerticalSpacing = useIsSmallVerticalSpacing();
  const isSmallHorizontalSpacing = useIsSmallHorizontalSpacing();

  return (
    <CardWithIntent intent="neutral">
      <CardContent
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          height: "100%",
          py: isSmallVerticalSpacing ? 1 : undefined,
          px: isSmallHorizontalSpacing ? 2 : 6,
        }}
      >
        <Stack
          alignItems="center"
          justifyContent="center"
          spacing={isSmallVerticalSpacing ? 2 : 5}
          sx={{
            textAlign: "center",
            textWrap: "balance",
            width: "100%",
            flexGrow: 1,
            mb: "auto",
          }}
        >
          <Illustration type="document-upload" />

          <Text semibold variant="h5">
            This workplace requires {requiredDocumentsCount}{" "}
            {pluralize("document", requiredDocumentsCount)}
          </Text>

          <Text
            color={(theme) => theme.palette.text.secondary}
            variant="body2"
            data-testid="bookability-sheet-description"
          >
            Please complete {requiredDocumentsCount} {pluralize("document", requiredDocumentsCount)}{" "}
            to apply to this job
          </Text>
        </Stack>

        <Box sx={{ width: "100%", mt: isSmallVerticalSpacing ? 2 : 5 }}>
          <Button fullWidth variant="contained" size="medium" onClick={onClick}>
            View details
          </Button>
        </Box>
      </CardContent>
    </CardWithIntent>
  );
}
